import React from "react";
import cx from "classnames";
import { Modal, ModalBody } from "reactstrap";
import { getSearchNames } from "../../services/getSearchOptions";
import Filter from "../../containers/Filter/Filter";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import CircleLeft from "../../icons/circle-left.svg";
import PropTypes from "prop-types";
import styles from "./ModalWithDropDown.module.scss";

const ModalWithDropDown = ({
  isOpen,
  toggleModal,
  selected,
  onSave,
  language,
  onChange,
  onClear,
  changeValidationError,
  className,
  options,
  btnEnterName,
  name,
  isMultiple
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => toggleModal()}
      className={cx(styles.modal, className)}
    >
      <div className={styles.header}>
        <Button
          className={styles.filterCloseButton}
          onClick={() => toggleModal(false)}
        >
          <Icon name={CircleLeft} />
        </Button>
        <h6>{getSearchNames(name)} </h6>
      </div>

      <ModalBody>

        <Filter
          options={options}
          isOpen={true}
          onSave={onSave}
          language={language}
          selected={selected}
          toggleModal={toggleModal}
          onChange={onChange}
          onClear={onClear}
          changeValidationError={changeValidationError}
          btnEnterName={btnEnterName}
          name={name}
          isMultiple={isMultiple}
        />
      </ModalBody>
    </Modal>
  );
};

ModalWithDropDown.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  selected: PropTypes.array,
  onSave: PropTypes.func,
  name: PropTypes.string,
  language: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  changeValidationError: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  options: PropTypes.array,
  btnEnterName: PropTypes.string,
};
ModalWithDropDown.dafaultProps = {
  isOpen: false,
  onSave: () => { },
  changeValidationError: () => { },
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ModalWithDropDown;
